// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sponsor-module--wrapper--1MBlm","hed":"sponsor-module--hed--12IdY","disclaimer":"sponsor-module--disclaimer--g1NyU","secondary":"sponsor-module--secondary--3upkN"};